import { todayLocalIsoDate } from "./date";

/** テキスト内容を指定ファイル名でブラウザにダウンロードさせる。 */
export function downloadTextFile(
  filename: string,
  content: string,
  mimeType = "text/csv;charset=utf-8",
): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  try {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}

/** YYYY-MM-DD 形式の当日文字列（ローカルタイム）。ファイル名用。 */
export function todayIso(): string {
  return todayLocalIsoDate();
}
